import { render, staticRenderFns } from "./home-collection-list.vue?vue&type=template&id=44fe4813&scoped=true"
import script from "./home-collection-list.vue?vue&type=script&lang=js"
export * from "./home-collection-list.vue?vue&type=script&lang=js"
import style0 from "./home-collection-list.vue?vue&type=style&index=0&id=44fe4813&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.105.4__lodash@4.18.1__yidcnbbritke6h73lk2rhpn7vi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fe4813",
  null
  
)

export default component.exports